import React from 'react'
import * as S from './styled'
import { H2Blue, UnderlineYellow } from './../../Typography'
import { Button } from '../../Button'
import { ResponsiveImage } from '../../ResponsiveImage'

const OurTeam = () => {
  return (
    <S.Wrapper>
      <div className="container">
        <H2Blue>Náš tým</H2Blue>
        <UnderlineYellow />
        <S.WrapRow>
          <div className="row align-items-center">
            <div className="col-md-6">
              <ResponsiveImage
                src={`/images/lukas-eisenwort.png`}
                alt="lukas-eisenwort"
              />
              <S.Name>
                Lukáš Eisenwort <br /> daňový poradce
              </S.Name>
            </div>
            <div className="col-md-6">
              <ResponsiveImage
                src={`/images/lukas-eisenwort.png`}
                alt="jan-kotala"
              />
              <S.Name>
                Jan Kotala <br /> daňový poradce
              </S.Name>
            </div>
          </div>
        </S.WrapRow>
        <Button>Další členové týmu</Button>
      </div>
    </S.Wrapper>
  )
}

export default OurTeam
